module.exports = __webpack_public_path__ + "static/media/section_4_C.122d798d.png";